module.exports = __webpack_public_path__ + "static/media/pdf_download.73c6473f.svg";